import React, { useEffect, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { css } from '@emotion/react';
import CloseSVG from '@birdi/icons/close.svg';
import { closeButtonCSS, contentCSS, portalCSS } from '@birdi/modal-kit';
import { BirdiTheme } from '@birdi/theme';
import {
  stroot,
  organisation as organisationAPI,
  user,
} from '@birdi/js-sdk';
import {
  buttonsHolderStyle,
  cancelButtonstyle,
  confirmButtonstyle,
} from './delete-workspace-modal';
import WorkspaceSelect from '@birdi/select/WorkspaceSelect';

interface AddUserToWorkspaceModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  scopeId: string;
  existingWorkspacesIds: Array<string>;
}

export const AddUserToWorkspaceModal: React.FC<AddUserToWorkspaceModalProps> = ({
  open,
  setOpen,
  scopeId,
  existingWorkspacesIds,
}) => {
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);

  const confirm = async () => {
    if (selectedWorkspace.value) {
      await organisationAPI.addUserToWorkspace(stroot('ieri3a'), scopeId, selectedWorkspace.value);
      window.location.reload();
    } else {
      // error
    }
  };
  const cancel = () => {
    setOpen(false);
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay />

        <div css={portalCSS}>
          <Dialog.Content
            css={(theme: BirdiTheme) => css`
              ${contentCSS(theme)};
              overflow-y: auto;
            `}
          >
            <Dialog.Close css={closeButtonCSS}>
              <CloseSVG />
            </Dialog.Close>
            <h2
              css={css`
                text-align: center;
              `}
            >
              Add user to workspace
            </h2>
            <hr />
            <div css={css`display: flex; flex-direction: column; justify-content: center; align-items: center`}>
              <p>
                Please choose the workspace you want to add this user to it:
              </p>
              <WorkspaceSelect
                placement="top"
                onChange={(workspace) => {
                  setSelectedWorkspace(workspace);
                }}
                placeholder='Select workspace'
                containerStyles={{ width: '18em' }}
                disabledOptions={existingWorkspacesIds}
              />
            </div>
            <div css={buttonsHolderStyle}>
              <button
                type="button"
                css={confirmButtonstyle}
                onClick={cancel}
              >
                <span>Cancel</span>
              </button>
              <button
                type="button"
                css={cancelButtonstyle}
                onClick={confirm}
                disabled={!selectedWorkspace}
              >
                <span>Confirm</span>
              </button>
            </div>
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
